/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { ChatBubbleComponent } from 'src/chatbot/components/chatBubble/chatBubble.component';
import { ChatInputFormComponent } from 'src/chatbot/components/chatInputForm/chatInputForm.component';
import { RecommendedMessagesComponent } from 'src/chatbot/components/recommendedMessages/recommendedMessages.component';
import { ScrollService } from 'src/chatbot/service/scrollContainer.service';
// import { TypingDotsComponent } from 'src/chatbot/components/typingDots/typingDots.component';
import { ChatHeaderComponent } from 'src/chatbot/components/chatHeader/chatHeader.component';
import { DataChatService } from '../service/dataChat.service';
import { TextAnimationComponent } from '../components/text-animation/text-animation.component';
import { BlobLoaderComponent } from 'src/app/shared/blob-loader/blob-loader.component';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'chat-view',
  standalone: true,
  imports: [
    CommonModule,
    ChatBubbleComponent,
    ChatInputFormComponent,
    RecommendedMessagesComponent,
    // TypingDotsComponent,
    ChatHeaderComponent,
    TextAnimationComponent,
    BlobLoaderComponent,
    TranslateModule
  ],
  templateUrl: './chatView.component.html',
  styleUrls: ['./chatView.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatViewComponent {
  @ViewChild('scrollContainer') private scrollContainer?: ElementRef;
  private _routerService = inject(Router);

  public scrollService = inject(ScrollService);
  public dataChat = inject(DataChatService);

  ngAfterViewInit(): void {
    this.scrollService.setScrollContainer(this.scrollContainer?.nativeElement);
  }

  scrollToBottom(): void {
    if (this.scrollContainer) {
      try {
        this.scrollContainer.nativeElement.scrollTop =
          this.scrollContainer.nativeElement.scrollHeight;
      } catch (err) {}
    }
  }

  protected checkIsCurrentRouteCustomRoute(): boolean {
    return this._routerService.url.includes('/custom-route/');
  }
}
